"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = exports.UserApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * UserApi - axios parameter creator
 * @export
 */
const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addNewUsersFrom365: async (options = {}) => {
            const localVarPath = `/api/user/addNewUsersFrom365`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IUserEntity} iUserEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUser: async (iUserEntity, options = {}) => {
            // verify required parameter 'iUserEntity' is not null or undefined
            (0, common_1.assertParamExists)('addUser', 'iUserEntity', iUserEntity);
            const localVarPath = `/api/user/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUserEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId, options = {}) => {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('deleteUser', 'userId', userId);
            const localVarPath = `/api/user/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (options = {}) => {
            const localVarPath = `/api/user/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {IUserEntity} iUserEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: async (iUserEntity, options = {}) => {
            // verify required parameter 'iUserEntity' is not null or undefined
            (0, common_1.assertParamExists)('updateUser', 'iUserEntity', iUserEntity);
            const localVarPath = `/api/user/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iUserEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi -
 */
var UserApi;
(function (UserApi) {
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof UserApi
     * url /api/user/addNewUsersFrom365
     */
    async function addNewUsersFrom365(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addNewUsersFrom365(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration));
    }
    UserApi.addNewUsersFrom365 = addNewUsersFrom365;
    /**
     *
     * @param {IUserEntity} iUserEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof UserApi
     * url /api/user/add
     */
    async function addUser(iUserEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addUser(iUserEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseIUserEntity)(res.data);
            return res;
        });
    }
    UserApi.addUser = addUser;
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof UserApi
     * url /api/user/delete
     */
    async function deleteUser(userId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    UserApi.deleteUser = deleteUser;
    /**
     *
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof UserApi
     * url /api/user/list
     */
    async function listUsers(options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseIUserEntity)(x));
            return res;
        });
    }
    UserApi.listUsers = listUsers;
    /**
     *
     * @param {IUserEntity} iUserEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof UserApi
     * url /api/user/update
     */
    async function updateUser(iUserEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.updateUser(iUserEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            return res;
        });
    }
    UserApi.updateUser = updateUser;
})(UserApi || (exports.UserApi = UserApi = {}));
